export default new class PopupAd {
    constructor() {
        this.popupNode = document.querySelector('.fs-popup-ad');

        if (!this.popupNode) return;

        this.counterNode = document.querySelector('.fs-popup-ad--counter');
        this.closeNode = document.querySelector('.fs-popup-ad--close');
        this.overlayNode = document.querySelector('.fs-popup-ad--overlay');

        this.classShow = 'fs--show';
        this.intervalId = null;
        this.popupTimeout = parseInt(this.popupNode.getAttribute('data-timeout'));

        this.compareStorageTimeStamp();
    }

    compareStorageTimeStamp() {
        const now = new Date().getTime();
        const timeout = this.convertToMilliseconds(0, this.popupTimeout);
        const userTimeStamp = parseInt(window.localStorage.getItem('popupAd'));
        const timeDiff = isNaN(userTimeStamp) ? timeout : timeout + userTimeStamp;

        timeDiff < now
            ? setTimeout(this.init, 3000)
            : null;
    }

    convertToMilliseconds(hours, min, sec = 0) {
        return ((hours * 60 * 60 + min * 60 + sec) * 1000);
    }

    init = () => {
        this.togglePopup();
        this.initCounter();
        this.attachEvents();
        this.updateTimeStamp();
    }

    updateTimeStamp() {
        window.localStorage.setItem('popupAd', new Date().getTime());
    }

    attachEvents() {
        this.closeNode.addEventListener('click', this.togglePopup);
    }

    togglePopup = () => {
        this.popupNode.classList.toggle(this.classShow);
        this.overlayNode.classList.toggle(this.classShow);
    }

    initCounter() {
        this.counterNode.classList.add(this.classShow);

        this.intervalId = setInterval(() => {
            let num = parseInt(this.counterNode.innerHTML);
            num > 0 ? this.counterNode.innerHTML = num - 1 : this.showClose();
        }, 1000)
    }

    showClose() {
        clearInterval(this.intervalId);

        this.closeNode.classList.add(this.classShow);
        this.counterNode.classList.remove(this.classShow);
    }
}